// extracted by mini-css-extract-plugin
module.exports = {"overrideWidth":"AssessmentReport_overrideWidth__3Ah5k"};